import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  *, ::before, ::after {
    box-sizing: border-box;
  }

  html {
    text-size-adjust: 100%;
  }

  body {
    margin: 0;
    padding: 0;

    font-family: Arial, sans-serif;
    font-size: 13px;
    color: var(--text-color);
    line-height: var(--base-line-height);

    background-color: var(--page-background-color);
  }

  h1, h2, h3, h4, h5, h6 {
    color: var(--heading-color);
    line-height: var(--heading-line-height);
    font-family: var(--heading-font-family);
    font-style: normal;

    margin-bottom: 6px;
    margin-top: 3px;

    text-rendering: optimizeLegibility;
  }

  h1 {
    font-size: 22px;
    font-weight: 700;
  }

  h2 {
    font-size: 18px;
    font-weight: 700;
  }

  h3 {
    font-size: 15px;
    font-weight: 600;
  }

  h4 {
    font-size: 13px;
    font-weight: 700;
  }

  h5 {
    font-weight: 700;
  }

  h6 {
    font-weight: 700;
  }

  a {
    color: var(--link-color);
    text-decoration: none;

    &:hover {
      cursor: pointer;
    }

    &:hover, &:focus {
      text-decoration: underline;
    }

    &[disabled] {
      pointer-events: none;
    }
  }

  button {
    cursor: pointer;
  }

  .cc-visuallyhidden {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }

  @media print {
    * {
      background: transparent !important;
      box-shadow: none !important;
      color: var(--black) !important;
      text-shadow: none !important;
    }
  }
`;
